import 'ng-dialog';
import 'angular-cookies';
import 'angular-resource';
import 'angular-sanitize';
// import ngRoute from 'angular-route';
import 'ngstorage';
import 'ng-csv';
import 'ng-tags-input';
import 'angular-ui-bootstrap';
import '../../main/apt';
import '../../clink_modification/clinkmod';
import '../../clink_modification/scripts/controllers/create';
import angular from 'angular';

// missing variable during migration
const useDigestHUD = false;

var modules = [
	'ngCookies',
	'ngResource',
	'ngSanitize',
	'ngCsv',
	// 'ngRoute',
	'ui.bootstrap',
	'ngDialog',
	'ngStorage',
	'ngTagsInput',
	'apt',
	'clinkModification'
]

if ( useDigestHUD === true ) {
	modules.push('digestHud')
}

var module = angular.module('clinkManager', modules)
// module.config(['$routeProvider', function($routeProvider) {
// 	$routeProvider
// 		.when('/', {
// 			templateUrl: '../clink_manager/views/main/main.html',
// 			controller: 'MainCtrl'
// 		})
// 		.otherwise({
// 			templateUrl: '../clink_manager/views/main/main.html',
// 			controller: 'MainCtrl'
// 		});
// }]);

if ( useDigestHUD ) {
	module.config(function(digestHudProvider) {
		digestHudProvider.enable();

		// Optional configuration settings:
		digestHudProvider.setHudPosition('top right'); // setup hud position on the page: top right, bottom left, etc. corner
		digestHudProvider.numTopWatches = 20;  // number of items to display in detailed table
		digestHudProvider.numDigestStats = 25;  // number of most recent digests to use for min/med/max stats
	})
}

module.filter('unique', function () {

	return function (items, filterOn) {
  
	  if (filterOn === false) {
		return items;
	  }
  
	  if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
		var newItems = [];
  
		var extractValueToCompare = function (item) {
		  if (angular.isObject(item) && angular.isString(filterOn)) {
			return item[filterOn];
		  } else {
			return item;
		  }
		};
  
		angular.forEach(items, function (item) {
		  var isDuplicate = false;
  
		  for (var i = 0; i < newItems.length; i++) {
			if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
			  isDuplicate = true;
			  break;
			}
		  }
		  if (!isDuplicate) {
			newItems.push(item);
		  }
  
		});
		items = newItems;
	  }
	  return items;
	};
  })

.filter('percentage', ['$filter', function ($filter) {
  return function (input, decimals) {
	  if ( input === '' || !isFinite(input) ) return '';
      return $filter('number')(input * 100, decimals) + '%';
  };
}]);

module.filter('join', ['$filter', function ($filter) {
	return function (array, delimiter) {
		if ( Array.isArray( array ) ) {
			return array.join( delimiter );
		}
		return String( array );
	};
}]);
module.filter('startFrom', function() {
	return function(input, start) {
			if(input) {
					start = +start; //parse to int
					return input.slice(start);
			}
			return [];
	}
})
export default module;